import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageTitle from "../../../Components/Common/PageTitle";
import Input from "../../../Components/Utils/Input";
import Button from "../../../Components/Utils/Button";

import {
  addMeasurementUnitAsync,
  deleteMeasurementUnitAsync,
  getMeasurementUnitsAsync,
  updateMeasurementUnitAsync,
} from "../../../Redux/MasterSlice";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Alert from "../../../Components/Utils/Alert";
import messageSlice from "../../../Redux/MessageSlice";

export default function MeasurementUnit() {
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState();
  const [loading, setLoading] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({ state: 0 });

  const { message } = useSelector((state) => state.message);

  const master = useSelector((state) => state.master);
  const measurementUnits = [...master.measurementUnits];

  const [formRole, setFormRole] = useState("add");

  //   const dispatch = useDispatch();
  useEffect(() => {
    dispatch(messageSlice.actions.clearMessage());
    // if (!can("View Attendance Sheet")) {
    //   navigate(`/not-found`);
    // }
    setInitialValues({
      id: null,
      name: "",
    });

    // dispatch(messageSlice.actions.clearMessage());
    if (measurementUnits.length === 0) {
      dispatch(getMeasurementUnitsAsync());
    }

    // dispatch(getOldStudentsAsync());
  }, [dispatch]);

  const onEdit = (event, measurementUnit) => {
    event.preventDefault();
    setInitialValues({
      id: measurementUnit.id,
      name: measurementUnit.name,
    });

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setFormRole("edit");
  };

  const onCancelEdit = (event) => {
    event.preventDefault();
    setInitialValues({
      id: null,
      name: "",
    });

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setFormRole("add");
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("This field is required!"),
  });

  const handleSubmit = async (payload, { resetForm }) => {
    dispatch(messageSlice.actions.clearMessage());
    setLoading(true);
    console.log(formRole);
    if (formRole === "edit") {
      await dispatch(updateMeasurementUnitAsync(payload)).unwrap();
    } else {
      await dispatch(addMeasurementUnitAsync(payload)).unwrap();
    }

    setLoading(false);
    setFormRole("add");
    resetForm();
    setInitialValues({
      id: null,
      name: "",
    });
  };
  const handleDelete = async (event, payload) => {
    event.target.disabled = true;
    dispatch(messageSlice.actions.clearMessage());
    if (deleteConfirm.state == 1) {
      await dispatch(deleteMeasurementUnitAsync(payload));
    }
    event.target.disabled = false;
    setDeleteConfirm({});
  };

  console.log(message);
  let thClass =
    " text-gray-600   border p-2  whitespace-nowrap dark:text-gray-400 font-bold pr-6 text-left text-sm tracking-normal leading-4";

  let tdClass =
    " text-gray-600 border p-2 whitespace-nowrap dark:text-gray-400 font-normal pr-6 text-left text-sm tracking-normal leading-4";

  return (
    <>
      <div className='py-2'>
        <div className='mx-auto container min-h-screen bg-white dark:bg-gray-800 shadow rounded'>
          <div className='w-full px-5   '>
            <PageTitle name='Measurement Units' />
            {message && <Alert message={message} />}
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form>
                <div className=' py-5 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 pt-6 gap-8'>
                  <Input
                    label={
                      formRole === "add"
                        ? "Create New Measurement Unit"
                        : "Edit Measurement Unit"
                    }
                    name='name'
                    placeholder='Enter Unit Name'
                  />

                  <div className='text-left mt-5'>
                    {formRole === "add" ? (
                      <Button
                        value={loading ? "Saving..." : "Save"}
                        icon={"SaveIcon"}
                        onClick={handleSubmit}
                      />
                    ) : (
                      <Button
                        value={loading ? "Updating..." : "Update"}
                        icon={"SaveIcon"}
                        onClick={handleSubmit}
                      />
                    )}

                    {formRole === "edit" && (
                      <button
                        type='button'
                        className='ml-5   text-red-600'
                        onClick={onCancelEdit}
                      >
                        Cancel Edit X
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            </Formik>

            <br />
            <table
              id='datatable'
              className='min-w-full   bg-white dark:bg-gray-800'
            >
              <thead>
                <tr>
                  <th className={thClass + "w-16"}>#</th>
                  <th className={thClass}>Name</th>
                  <th colSpan='2' className={thClass}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {measurementUnits.length > 0 &&
                  measurementUnits.map((unit, i) => {
                    return (
                      <tr
                        key={unit.id}
                        className='odd:bg-white even:bg-gray-50'
                      >
                        <td className={tdClass + "w-32"}>{++i}</td>
                        <td className={tdClass}>{unit.name}</td>
                        <td className={tdClass}>
                          <button
                            className='bg-blue-500  hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'
                            onClick={(event) => onEdit(event, unit)}
                          >
                            Edit
                          </button>
                        </td>
                        <td className={tdClass}>
                          {(deleteConfirm.state == 0 ||
                            deleteConfirm.itemId != unit.id) && (
                            <button
                              className='bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded'
                              onClick={() =>
                                setDeleteConfirm({
                                  itemId: unit.id,
                                  state: 1,
                                })
                              }
                            >
                              Delete
                            </button>
                          )}
                          {deleteConfirm.state == 1 &&
                            deleteConfirm.itemId == unit.id && (
                              <>
                                <p className='text-red-700'> Are You Sure? </p>

                                <button
                                  className='outline-button-danger'
                                  onClick={(event) => handleDelete(event, unit)}
                                >
                                  Yes
                                </button>
                                <span className='mr-2'></span>
                                <button
                                  className='outline-button-success'
                                  onClick={() => setDeleteConfirm({})}
                                >
                                  No
                                </button>
                              </>
                            )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
